import LinkDecorator from './LinkDecorator'

const createLinkPlugin = () => {
  return {
    decorators: [LinkDecorator],
  }
}

export default createLinkPlugin
